var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { width: "26", height: "26", rx: "8", fill: "#D1D1D1" }),
    React.createElement(
      "g",
      { clipPath: "url(#clip0_15676_6394)" },
      React.createElement("path", { d: "M19.125 12.072c-.01-.08-.027-.16-.052-.236v-.079a.935.935 0 0 0-.167-.245l-5.25-5.25a.935.935 0 0 0-.245-.166h-.079L13.053 6H9.5a2.625 2.625 0 0 0-2.625 2.625v8.75A2.625 2.625 0 0 0 9.5 20h7a2.625 2.625 0 0 0 2.625-2.625v-5.25-.053zm-5.25-3.088l2.266 2.266H14.75a.875.875 0 0 1-.875-.875V8.984zm3.5 8.391a.875.875 0 0 1-.875.875h-7a.875.875 0 0 1-.875-.875v-8.75A.875.875 0 0 1 9.5 7.75h2.625v2.625A2.625 2.625 0 0 0 14.75 13h2.625v4.375z", fill: "#fff" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "clip0_15676_6394" },
        React.createElement("path", { fill: "#fff", transform: "translate(6 6)", d: "M0 0h14v14H0z" })
      )
    )
  );
});